import { EmailProviders } from '../util/constants';
import ApiService from './api-service';

const NylasService = {
  async connectNylas({ shortCode, email = '', provider = EmailProviders.GOOGLE }) {
    const body = {
      query: `mutation connectNylas ($email: String, $provider: String) {
        connectNylas (email: $email, provider: $provider) {
          url
        }
      }`,
      variables: {
        email,
        provider,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.connectNylas.url;
  },
  async setNylasToken({ shortCode, code, state }) {
    const body = {
      query: `
      mutation setNylasToken ($code: String!, $state: String!) {
        setNylasToken(code: $code, state: $state)
      }`,
      variables: {
        code,
        state,
      },
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data;
  },
  async disconnectNylas({ shortCode, senderId }) {
    const body = {
      query: `
      mutation disconnectNylas ($senderId: String!) {
        disconnectNylas(senderId: $senderId)
      }`,
      variables: {
        senderId,
      },
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data;
  },
  async removeNylas({ shortCode, senderId }) {
    const body = {
      query: `
      mutation removeNylas ($senderId: String!) {
        removeNylas(senderId: $senderId)
      }`,
      variables: {
        senderId,
      },
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data;
  },
};

export default NylasService;
